import 'jquery';
import '../utils/slick.js';

$(function () {
  var slider = $('.feature-list .feature-list__list.mobile');
  var cards = $('.feature-list .feature-list__row');

  function initSlider() {
    slider.css('opacity', 0);
    slider.on('init', function () {
      slider.css('opacity', 1);
    });

    slider.slick({
      slidesToShow: 2,
      prevArrow: '<div class="arrow-left"></div>',
      nextArrow: '<div class="arrow-right"></div>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  function destroySlider() {
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  }

  function removeSalAnimate() {
    cards.each(function () {
      $(this).removeClass('sal-animate');
      $(this).removeAttr('data-sal');
      $(this).removeAttr('data-sal-duration');
      $(this).removeAttr('data-sal-delay');
    });
  }

  function handleResize() {
    var isMobile = $(window).width() <= 992;

    if (isMobile && !slider.hasClass('slick-initialized')) {
      removeSalAnimate();
      initSlider();
    } else if (!isMobile && slider.hasClass('slick-initialized')) {
      destroySlider();
    }
  }

  handleResize();

  window.addEventListener('resize', function () {
    setTimeout(function () {
      handleResize();
    }, 100);
  });
});
